// default app vars

let g_dev = false;
let g_windowHeight = $(window).height();
let g_windowWidth = $(window).width();
let g_scroll = $(window).scrollTop();

// custom vars
let scrollMargin = 20;
let scrollTreshold = 25;

$(document).ready(function() {
    // projects masonry
    $('.masonry').masonry({
        itemSelector: '.masonry-item'
    });

    // rtoggle more projects
    $('[data-toggle-more]').click(function (e) {
        e.preventDefault();
        let target =  $(this).data('toggleMore');
        // toggle elements
        $(this).closest('[data-toggle-more-parent="'+target+'"]').hide();
        $('[data-toggle-more-target="'+target+'"]').show();

        // re-init masonry
        $('.masonry').masonry({
            itemSelector: '.masonry-item'
        });
    });
});

$(window).on('scroll', function () {
    g_scroll = $(window).scrollTop();
});

// On windows.resize
$(window).on('resize', function () {
    // Set window height/width on resize
    g_windowHeight = $(window).height();
    g_windowWidth = $(window).width();
});

var btn = $('.back-to-top svg');

btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
});
